import { forwardRef } from "react";
import { ReactComponent as CheckIcon } from "../../assets/Check-icon.svg";

const ConfirmModal = forwardRef(function ConfirmModal(_props, modalRef) {
  return (
    <dialog
      ref={modalRef}
      className="rounded-xl md:w-1/2 lg:w-1/3 border border-[#DEE2E7] dark:border-[#3D404B]"
    >
      <div className=" p-5 ">
        <div className="flex flex-col gap-3 items-center  text-center">
          <CheckIcon className="w-36 h-36 " />
          <h3 className="font-bold">Transactions has been initiated</h3>
          <p>
            Your Transaction to contribute{" "}
            <span className="font-bold">{_props.amount} RWF</span> has been sent
            to <span className="font-bold">{_props.phone} </span>
            MOMO account for approval.
          </p>
          <p>
            Please dial{" "}
            <a href="tel:*182*7*1#" className="text-[#2576D6]">
              *182*7*1#
            </a>{" "}
            for Approval.
          </p>
          <p className="font-bold my-3">Thank you For Your Contribution.</p>
        </div>
        <div className="w-full my-4">
          <form method="dialog">
            {/* if there is a button in form, it will close the modal */}
            <button
              type="submit"
              className="w-full text-white bg-defaultGreen hover focus:outline-none  font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700  disabled:cursor-not-allowed disabled:bg-defaultGreen/70 disabled:dark:bg-defaultGreen/50 disabled:text-gray-400 disabled:dark:text-gray-600"
              onClick={() => {}}
            >
              Close
            </button>
          </form>
        </div>
      </div>
    </dialog>
  );
});

export default ConfirmModal;
